/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description modals selectors
 */

import type { MODAL_TYPE, State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectModals = (state: State) => {
  return state.modals
}

export const selectOpen = (state: State, type?: MODAL_TYPE) => {
  const openModal = selectOpenModal(state)
  if (type) {
    return !!openModal && openModal === type
  }
  return !!openModal
}

export const selectOpenModal = compose((modals) => modals.open, selectModals)
